import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import ScrollToTopNavigation from './Include/ScrollToTopNavigation'

import Loader from './Include/Loader';
import Header from './Include/Header';
import Footer from './Include/Footer';


const Home = React.lazy(() => import('./Components/Home'))
const ContactUs = React.lazy(() => import( './Components/ContactUs'))
const About = React.lazy(() => import('./Components/About'))
const Faq = React.lazy(() => import('./Components/Faq'))
const Blog = React.lazy(() => import('./Components/Blog'))
const Service = React.lazy(() => import('./Components/Service'))
const Carrer = React.lazy(() => import( './Components/Carrer'))
const ContentWriting = React.lazy(() => import( './Components/ContentWriting'))
const IndustrialTraining = React.lazy(() => import('./Components/IndustrialTraining'))


const BlogDetails = React.lazy(() => import( './Components/BlogDetails'))
const TermsandConditions = React.lazy(() => import('./Components/TermsandConditions'))


const App = () => {
  return (
    <Suspense fallback={<Loader/>}>
       <Header/>
      <Routes>
       
        <Route path='/' element={<Home />} />
        <Route path='/contact' element={<ContactUs />} />
        <Route path='/about' element={<About />} />
        <Route path='/faq' element={<Faq />} />
        <Route path='/blog' element={<Blog />} />
        <Route path='/service/:id' element={<Service />} />
        <Route path='/content-writing' element={<ContentWriting />} />
        <Route path='/industrial-training' element={<IndustrialTraining />} />
        <Route path='/about/career' element={<Carrer />} />
        
        <Route path='/blog/:id' element={<BlogDetails />} />
        <Route path='/terms-and-conditions' element={<TermsandConditions/>}/>
      </Routes>
      <ScrollToTopNavigation/>
      <Footer/>
    </Suspense>

  );
}

export default App;
